// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-container {
  padding: 3rem;
  width: 65%;
  margin-top: -5rem;
  border-radius: 5px;
  background: #FFFFFF30;

  .contact-h2 {
    text-align: center;
    color: white;
    font-size: 3rem;
    text-decoration: underline;
    margin-bottom: 3rem;
  }

  >div {

    display: grid;
    gap: 2rem;
    grid-template: 1fr 1fr / 1fr 1fr;

    .card {
      color: black;
      padding: 1rem;
      border-radius: 5px;
      background: gold;
      outline: 2px solid black;

      h2 {
        margin-bottom: 0;
      }

      p {
        margin-top: 5px;
      }
    }

    .location {
      grid-area: 1 / 2 / -1 / -1;
    }
  }
}`, "",{"version":3,"sources":["webpack://./src/contact/contact.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;;EAErB;IACE,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,0BAA0B;IAC1B,mBAAmB;EACrB;;EAEA;;IAEE,aAAa;IACb,SAAS;IACT,gCAAgC;;IAEhC;MACE,YAAY;MACZ,aAAa;MACb,kBAAkB;MAClB,gBAAgB;MAChB,wBAAwB;;MAExB;QACE,gBAAgB;MAClB;;MAEA;QACE,eAAe;MACjB;IACF;;IAEA;MACE,0BAA0B;IAC5B;EACF;AACF","sourcesContent":[".contact-container {\n  padding: 3rem;\n  width: 65%;\n  margin-top: -5rem;\n  border-radius: 5px;\n  background: #FFFFFF30;\n\n  .contact-h2 {\n    text-align: center;\n    color: white;\n    font-size: 3rem;\n    text-decoration: underline;\n    margin-bottom: 3rem;\n  }\n\n  >div {\n\n    display: grid;\n    gap: 2rem;\n    grid-template: 1fr 1fr / 1fr 1fr;\n\n    .card {\n      color: black;\n      padding: 1rem;\n      border-radius: 5px;\n      background: gold;\n      outline: 2px solid black;\n\n      h2 {\n        margin-bottom: 0;\n      }\n\n      p {\n        margin-top: 5px;\n      }\n    }\n\n    .location {\n      grid-area: 1 / 2 / -1 / -1;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
